import React from 'react';
import AccountRolePermission from '../AccountRole&Permission';

const AccountAddRoleMangement = () => {
  return (
    <div>
      <AccountRolePermission/>
    </div>
  );
}

export default AccountAddRoleMangement;

